import { __rest } from "tslib";
import React, { useState, useMemo } from 'react';
import moment, { isMoment } from 'moment';
import DatePicker from 'react-datepicker';
import classnames from 'classnames';
import { CustomDatePickerInput } from '../FormComponents/ScheduleDatePicker';
import styles from './timesteppicker.module.scss';
const TimeStepPicker = (_a) => {
    var { style, className, onChange, timeIntervals = 15, disabled, defaultTime = true, filterTime, onKeyDown, popperStrategy, offset, value } = _a, props = __rest(_a, ["style", "className", "onChange", "timeIntervals", "disabled", "defaultTime", "filterTime", "onKeyDown", "popperStrategy", "offset", "value"]);
    const [time, setTime] = useState(defaultTime ? new Date() : null);
    const handleChange = date => {
        if (!Array.isArray(date)) {
            if (offset === undefined) {
                if (onChange) {
                    onChange(date ? moment(date) : null);
                }
                else {
                    setTime(date);
                }
            }
            else {
                if (onChange) {
                    const localDate = new Date();
                    const localOffset = localDate.getTimezoneOffset();
                    const targetTime = date ? new Date(date.getTime() + (-localOffset - offset) * 60000) : null;
                    onChange(targetTime ? moment(targetTime) : null);
                }
                else {
                    setTime(date);
                }
            }
        }
    };
    const selected = useMemo(() => {
        if (offset === undefined) {
            return isMoment(value) ? value.toDate() : time;
        }
        else {
            const localDate = new Date();
            const localOffset = localDate.getTimezoneOffset();
            const originDate = isMoment(value) ? value.toDate() : time;
            const targetTime = originDate ? new Date(originDate.getTime() + (offset + localOffset) * 60000) : undefined;
            return targetTime;
        }
    }, [offset, value, time]);
    return (React.createElement("div", { className: styles.wrapper },
        React.createElement(DatePicker, { disabled: disabled, closeOnScroll: !0, customInput: React.createElement(CustomDatePickerInput, { disabled: disabled, className: classnames(className, styles.input), style: Object.assign({}, style) }), popperProps: { strategy: popperStrategy }, isClearable: false, showPopperArrow: false, selected: selected, onChange: handleChange, showTimeSelect: true, showTimeSelectOnly: true, timeIntervals: timeIntervals, dateFormat: "HH:mm", timeFormat: "HH:mm", renderCustomHeader: () => React.createElement("span", null), timeCaption: "", timeClassName: () => styles.timeLi, filterTime: filterTime, onKeyDown: onKeyDown })));
};
export default TimeStepPicker;
